import * as types from './constants';

// Update Regularusers Group
export const updateRegularusersGroupRequest = data => (
  { type: types.UPDATE_REGULARUSERS_GROUP_REQUEST, payload: data }
);

export const updateRegularusersGroupDone = data => (
  { type: types.UPDATE_REGULARUSERS_GROUP_DONE, payload: data }
);

export const updateRegularusersGroupFailed = errors => (
  { type: types.UPDATE_REGULARUSERS_GROUP_FAILED, payload: errors }
);